import { typography } from '@joor/design-system'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 56px;
  padding: 8px;
  border: 1px solid var(--color-primary-200);
  border-radius: 5px;
  text-align: center;
  overflow: hidden;
  line-height: 1;
`

const Quantity = styled.div`
  ${typography.alpha.primaryActive.subtitle1}
  white-space: normal;
`

const Label = styled.div`
  ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-400);
  margin-top: 5px;
`

type AmountItemProps = {
  quantity: number
  label: string
  testId?: string
  valueTestId?: string
}

export const AmountItem = ({
  quantity,
  label,
  testId,
  valueTestId,
}: AmountItemProps) => (
  <Container data-testid={testId}>
    <Quantity data-testid={valueTestId}>{quantity}</Quantity>
    <Label>{label}</Label>
  </Container>
)
